module.exports = __webpack_public_path__ + "img/device-nighthawk.d3810dec.svg";